import { render } from "./RemoveComp.vue?vue&type=template&id=f49d1f50&scoped=true"
import script from "./RemoveComp.vue?vue&type=script&lang=js"
export * from "./RemoveComp.vue?vue&type=script&lang=js"

import "./RemoveComp.vue?vue&type=style&index=0&id=f49d1f50&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\projects\\SwitchQ-Websockets\\websockets-manager-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f49d1f50"]])

export default __exports__